<template>
<div class="idValidate">
  <div class="card">
    <div class="title">{{$t('User.authentication')}}</div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-row
        :gutter="20"
      >
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
        >
          <el-form-item
            :label="$t('User.cardType')"
            prop="certType"
          >
            <el-select
              style="width: 100%;"
              :placeholder="$t('please_enter')"
              v-model="form.certType"
            >
              <el-option
                v-for="(item,index) in cardTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
        >
          <el-form-item
            :label="$t('Register.idNo')"
            prop="idNum"
          >
            <el-input
              :placeholder="$t('please_enter')"
              v-model="form.idNum"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <h5 class="h5-el">{{$t('Upload_ID_photo')}}</h5>
          <div class="tips-box">
            <i class="el-icon-info icon-el"></i>
            <span class="tips-text">{{$t('Make_sure_the_ID_photo_document_shows_your_photo_full_name_date_of_birth_and_document_issue_date')}}</span>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
        >
          <div class="demo-box right-demo">
            <div class="img-out">
              <img
                :style="demoImgStyle"
                class="image-el"
                :src="rightDemoUrl" alt="">
            </div>
            <div class="img-right">
              <h3 class="subtitle">{{$t('Demonstrate_correctly')}}</h3>
              <ol>
                <li
                  class="dot-li"
                  v-for="(item,index) in passportRightTips"
                  :key="index"
                >
                  <span class="dot"></span>
                  {{item}}
                </li>
              </ol>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
        >
          <div class="demo-box wrong-demo">
            <div class="img-out">
              <img
                :style="demoImgStyle"
                class="image-el"
                :src="wrongDemoUrl"
                alt="">
            </div>
            <div class="img-right">
              <h3 class="subtitle">{{$t('Error_demonstration')}}</h3>
              <ol>
                <li
                  class="dot-li"
                  v-for="(item,index) in wrongTips"
                  :key="index"
                >
                  <span class="dot"></span>
                  {{item}}
                </li>
              </ol>
            </div>
          </div>
        </el-col>
<!--        手持证件照 todo-->
        <el-col>
          <div class="tips-box">
            <i class="el-icon-info icon-el"></i>
            <span class="tips-text">{{$t('Make_sure_the_photo_holding_your_ID_shows_your_face_your_ID_card_is_not_blocked_and_the_text_on_your_ID_card_is_clear')}}</span>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
        >
          <div class="demo-box right-demo">
            <div class="img-out">
              <img
                style="width: 178px;"
                class="image-el"
                src="../../assets/images/customer/auth/hander-right.png" alt="">
            </div>
            <div class="img-right">
              <h3 class="subtitle">{{$t('Demonstrate_correctly')}}</h3>
              <ol>
                <li
                  class="dot-li"
                  v-for="(item,index) in $t('handerImgRightTips')"
                  :key="index"
                >
                  <span class="dot"></span>
                  {{item}}
                </li>
              </ol>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
        >
          <div class="demo-box wrong-demo">
            <div class="img-out">
              <img
                style="width: 178px;"
                class="image-el"
                src="../../assets/images/customer/auth/handler-wrong.png"
                alt="">
            </div>
            <div class="img-right">
              <h3 class="subtitle">{{$t('Error_demonstration')}}</h3>
              <ol>
                <li
                  class="dot-li"
                  v-for="(item,index) in $t('handerImgWrongTips')"
                  :key="index"
                >
                  <span class="dot"></span>
                  {{item}}
                </li>
              </ol>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="two-img-box">
        <el-form-item
          :label="firstImgLabel"
          prop="firstImgUrl"
          class="inline-block-form-item front"
        >
          <upload-img-tips></upload-img-tips>
          <el-upload
            class="avatar-uploader"
            action="''"
            :accept="$config.imgFormat"
            :show-file-list="false"
            :http-request="uploadFront"
            :before-upload="beforeAvatarUpload"
            v-loading="firstImgLoading"
          >
            <img
              v-if="form.firstImgUrl"
              :src="form.firstImgUrl"
              class="avatar middle"
            >
            <div v-else class="avatar-uploader-btn idimg">
              <i  class="el-icon-plus avatar-uploader-icon"></i>
              <span class="id-img-desc">{{$t('Support_jpg_or_png_format')}}</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="secondFlag"
          :label="$t('ID_photo_reverse_side')"
          prop="secondImgUrl"
          class="inline-block-form-item back"
        >
          <upload-img-tips></upload-img-tips>
          <el-upload
            class="avatar-uploader"
            action="''"
            :accept="$config.imgFormat"
            :show-file-list="false"
            :http-request="uploadBack"
            :before-upload="beforeAvatarUpload"
            v-loading="secondImgLoading"
          >
            <img
              v-if="form.secondImgUrl"
              :src="form.secondImgUrl"
              class="avatar middle"
            >
            <div v-else class="avatar-uploader-btn idimg">
              <i  class="el-icon-plus avatar-uploader-icon"></i>
              <span class="id-img-desc">{{$t('Support_jpg_or_png_format')}}</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          :label="$t('Holding_ID_photo')"
          prop="handleCertImgUrl"
          class="inline-block-form-item back"
        >
          <upload-img-tips></upload-img-tips>
          <el-upload
            class="avatar-uploader"
            action="''"
            :accept="$config.imgFormat"
            :show-file-list="false"
            :http-request="uploadIdHand"
            :before-upload="beforeAvatarUpload"
            v-loading="handleCertImgLoading"
          >
            <img
              v-if="form.handleCertImgUrl"
              :src="form.handleCertImgUrl"
              class="avatar middle"
            >
            <div v-else class="avatar-uploader-btn idimg">
              <i  class="el-icon-plus avatar-uploader-icon"></i>
              <span class="id-img-desc">{{$t('Support_jpg_or_png_format')}}</span>
            </div>
          </el-upload>
        </el-form-item>
      </div>
    </el-form>
  </div>
  <div class="btn-line">
    <vs-button
      color="primary"
      type="border"
      class="next-btn"
      @click="prevHandle">{{$t('root.upper')}}</vs-button>
    <vs-button @click="nextHandle">{{$t('root.next')}}</vs-button>
  </div>
</div>
</template>

<script>
import{ showMessage,limitImageSizeFormat } from '@/utils/common';
import { mapGetters } from 'vuex'
import { savePerfectInfoStep } from '@/api/userCenter.js';

import driveDemoRightUrl from '../../assets/images/customer/auth/drivers-do.png'
import driveDemoWrongUrl from '../../assets/images/customer/auth/drivers-dont.png'
import passportDemoRightUrl from '../../assets/images/customer/auth/passport-do.png'
import passportDemoWrongUrl from '../../assets/images/customer/auth/passport-dont.png'


import idDemoRightUrl from '../../assets/images/customer/auth/id-card-do.png'
import idDemoWrongUrl from '../../assets/images/customer/auth/id-card-dont.png'

import residenceDemoRightUrl from '../../assets/images/customer/auth/residence-permit-do.png'
import residenceDemoWrongUrl from '../../assets/images/customer/auth/residence-permit-dont.png'

export default {
  name: "idValidate",
  props: {
    allData:{
      type: Object,
      default(){
        return {}
      }
    },
    cardTypeList:{
      type: Array,
      default(){
        return [];
      }
    }
  },
  data() {
    let _this = this;
    return {
      cardTypeListMock: [
        /*{label: '身份证',value: '1'},两张图片,
        {label: '护照',value: '2'}, 1张图片
        {label: '驾照',value: '3'}, 1张图片
        {label: '户口本',value: '4'},2张图片
        {label: '居住证',value: '5'}, 2张图片

        */
      ],
      form: {
        certType: '1', // 默认是1
        idNum: '',
        // passportUrl: '', //护照照片 todo
        firstImgUrl: '', //统一归到第一个图片
        secondImgUrl: '', //第二个图片
        handleCertImgUrl: '', //手持证件照片
      },
      rules: {
        certType:[
          { required: true, message: _this.$t('please_choose'), trigger: 'change' },
        ],
        idNum:[
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
        ],
        firstImgUrl:[
          { required: true, message: _this.$t('Please_upload'), trigger: 'change' },
        ],
        secondImgUrl:[
          { required: true, message: _this.$t('Please_upload'), trigger: 'change' },
        ],
      },
      passportRightTips: [
        _this.$t('Photos_are_clear'),
        _this.$t('Details_clearly_visible'),
        _this.$t('Photo_quality'),
        _this.$t('All_four_corners_of_the_document_are_visible'),
      ],
      wrongTips: [
        _this.$t('Photo_is_blurry_and_out_of_focus'),
        _this.$t('Details_not_shown_clearly'),
        _this.$t('Photo_quality_is_low_too_dark_or_too_bright'),
        _this.$t('All_four_corners_not_shown'),
      ],
      firstImgLoading: false,
      secondImgLoading: false,
      handleCertImgLoading: false,
    }
  },
  watch:{
    allData(news){
      this.form.certType = news.certType == null ? '1' : this.parseString(news.certType);
      this.form.idNum = news.certId;

      this.form.firstImgUrl = news.certValidatedImgFrontUrl;
      this.form.secondImgUrl = news.certValidatedImgBackUrl;
      this.form.handleCertImgUrl = news.handleCertImgUrl;
      /*this.form.handleCertImgName = news.handleCertImg;
      this.form.handleCertImgUrl = news.handleCertImgUrl;*/
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 正确示范的图片
    rightDemoUrl() {
      switch (this.form.certType){
        case '1':
          return idDemoRightUrl;
        case '2':
          return passportDemoRightUrl;
        case '3':
          return driveDemoRightUrl;
        case '4':
        case '5':
          return residenceDemoRightUrl;
      }
    },
    // 错误示范的图片
    wrongDemoUrl(){
      switch (this.form.certType){
        case '1':
          return idDemoWrongUrl;
        case '2':
          return passportDemoWrongUrl;
        case '3':
          return driveDemoWrongUrl;
        case '4':
        case '5':
          return residenceDemoWrongUrl;
      }
    },
    demoImgStyle(){
      if(this.form.certType == '2'){
        return {
          width: '100px',
          height: '140px',
        }
      }else if(this.form.certType == '1' || this.form.certType == '3' || this.form.certType == '4' || this.form.certType == '5'){
        return {
          width: '190px',
          height: '120px',
        }
      }
    },
    firstImgLabel(){
      if(this.form.certType == '1' || this.form.certType == '2'){
        return this.$t('ID_photo');
      }else {
        return this.$t('ID_photo_front');
      }
    },
    secondFlag(){
      switch (this.form.certType) {
        case '1':
        case '4':
        case '5':
          return true;
        case '2':
        case '3':
          return false;
      }
    }
  },
  methods: {
    // 上传图片的限制
    beforeAvatarUpload(file){
      return limitImageSizeFormat(file,this);
    },
    // 上传身份证前面
    uploadFront(item){
      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);

        this.firstImgLoading = true;
        this.$uploadFile(file).then((res) => {
          this.firstImgLoading = false;
          this.form.firstImgUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.firstImgLoading = false;
        })
      });
    },
    uploadBack(item){

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);

        this.secondImgLoading = true;
        this.$uploadFile(file).then((res) => {
          this.secondImgLoading = false;
          this.form.secondImgUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.secondImgLoading = false;
        })
      });

    },
    uploadIdHand(item){

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);

        this.handleCertImgLoading = true;
        this.$uploadFile(file).then((res) => {
          this.handleCertImgLoading = false;
          this.form.handleCertImgUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.handleCertImgLoading = false;
        })
      });

    },
    prevHandle(){
      this.$emit('prev-step');
    },
    getParams(){
      let params = {
        certType: this.form.certType,
        certId: this.form.idNum,
        certValidatedImgFront: this.form.firstImgUrl,

        // addressImg: this.form.addressUrlName,
      }
      if(this.secondFlag){
        params.certValidatedImgBack = this.form.secondImgUrl;
      }
      if(this.form.handleCertImgUrl){
        params.handleCertImg = this.form.handleCertImgUrl;
      }
      return params;
    },

    nextHandle(){
      this.$refs.form.validate((valid) => {
        if(valid){
          let Parmas = {
            profileProgress: 2,
            ...this.getParams(),
          };

          savePerfectInfoStep({
            ...Parmas,
            id: this.userInfo.id
          }).then((res) => {
            this.$emit('next-step');
          })
        }else {
          console.log('no-pass');
        }
      })
    },
    parseString(parmas){
      return parmas + '';
    }
  },
}
</script>

<style lang="scss" scoped>



.idValidate {
  .tips-box {
    display: inline-block;
    background-color: rgba(186, 191, 199, 0.12);
    border-radius: 5px;
    padding: 10px;
    align-items: center;
    margin-bottom: 10px;
    .icon-el {
      margin-right: 10px;
      color: rgba(186, 191, 199, 1);
    }
  }
  .demo-box {
    margin-bottom: 26px;
    .img-out {
      margin-right: 20px;
      .image-el {

      }
    }
    .subtitle {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 12px;
      color: #D85E5F;
    }
    .dot-li {
      padding-left: 10px;
      position: relative;
      .dot {
        width: 4px;
        height: 4px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        background-color: #6E6B7B;
      }
    }
    &.right-demo {
      .subtitle {
        color: #41B883;
      }
    }
  }
  .two-img-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  .inline-block-form-item {
    display: inline-block;
    &.front,
    &.back {
      margin-right: 24px;
    }
  }
  .avatar {
    width: 200px;
    height: 120px;
  }
}
</style>
